module.exports = __webpack_public_path__ + "static/media/046.013c3364.png";